import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateNoOfSets } from "../../../api/caseApi";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { updateNoOfSetsSchema } from "../schema/updateNoOfSetsSchema";
const UpdateNoOfSetsDialog = ({
  openUpdateNoOfSets,
  handleCloseUpdateNoOfSets,
  caseId,
  getSetsInfo,
  getCaseData,
  termsOfPayment2,
  handleSetAlertMessage,
  handleOpenAlert,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(updateNoOfSetsSchema),
  });
  console.log(termsOfPayment2);
  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseId = caseId;
    reset({ ...defaultValues });
  }, [caseId, reset]);

  const submitUpdateNoOfSets = async (values) => {
    const maxValue = Math.max(values.upper, values.lower);
    console.log(maxValue);

    if (
      termsOfPayment2?.type === 1 &&
      termsOfPayment2?.paymentSchedules[0]?.step === 4 &&
      termsOfPayment2?.paymentSchedules[0]?.amountOrNumberOfSets > maxValue
    ) {
      console.log("herwe");
      handleSetAlertMessage(
        "The maximum value between upper and lower set should be greater than or equal to the number of payments"
      );
      handleOpenAlert();
    } else if (5 > maxValue) {
      handleSetAlertMessage(
        "The maximum value between upper and lower set should be greater than or equal to the minimum number of sets to be fabricated which is 5"
      );
      handleOpenAlert();
    } else {
      console.log(values);
      await updateNoOfSets(values);
      await getSetsInfo();
      handleCloseUpdateNoOfSets();
    }
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateNoOfSets}
        onClose={handleCloseUpdateNoOfSets}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update No. of Sets</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateNoOfSets)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  type="number"
                  label="Upper"
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.upper}
                  helperText={errors.upper?.message}
                  {...register("upper")}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  type="number"
                  label="Lower"
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.lower}
                  helperText={errors.lower?.message}
                  {...register("lower")}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton theme="purple" onClick={handleCloseUpdateNoOfSets}>
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateNoOfSetsDialog;
